var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4264 16H22.5736C18.9431 16 16 18.9431 16 22.5736V41.4264C16 45.0569 18.9431 48 22.5736 48H41.4264C45.0569 48 48 45.0569 48 41.4264V22.5736C48 18.9431 45.0569 16 41.4264 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7595 24.6668H44V20.0002H39.1438C39.1438 20.0002 36.0875 19.9328 34.145 22.2471C34.145 22.2471 32.8193 23.3937 32.8009 26.7451V30.244H28V35.1973H32.8009V48H38.3383V35.1973H43.1024L43.7652 30.244H38.3383V26.7451C38.3521 26.3531 38.5409 24.6331 40.7687 24.6668",
    fill: "#05141F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.0e56047afef620a3e35876c4e59270b5.svg";
export { ForwardRef as ReactComponent };